import { render, staticRenderFns } from "./TeamJob.vue?vue&type=template&id=06c3f3f0&"
import script from "./TeamJob.vue?vue&type=script&lang=js&"
export * from "./TeamJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports